/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();



// **HEADER MENU SCRIPT**

function showShip() {
    document.getElementById('mainList').style.display = 'none';
    document.getElementById('shipList').style.display = 'block';
}

function showLocations() {
    document.getElementById('mainList').style.display = 'none';
    document.getElementById('locationsList').style.display = 'block';
}

function showMainList() {
    document.getElementById('shipList').style.display = 'none';
    document.getElementById('locationsList').style.display = 'none';
    document.getElementById('mainList').style.display = 'block';
}

const siteHeaderMobileNav = document.querySelector('.site-header__mobile-nav');
const mobileDrawerFooter = document.querySelector('.mobile-drawer-footer');

// Create the Intersection Observer
const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // Element is visible - add the 'visible' class to show it
      mobileDrawerFooter.classList.add('visible');
    } else {
      // Element is not visible - remove the 'visible' class to hide it
      mobileDrawerFooter.classList.remove('visible');
    }
  });
});

// Observe the element
observer.observe(siteHeaderMobileNav);


/* ------------------------------------------------ */


// ** BUILD YOUR BOX FUNCTIONALITY

window.addEventListener('load', () => {
  // Function to initialize toggle for a swatch item
  function initializeToggle(swatchItem) {
    const infiniteButton = swatchItem.querySelector('.spb-productdescfont');
    const infiniteContent = swatchItem.querySelector('span');

    if (infiniteButton && infiniteContent) {
      // Prevent duplicate event listeners
      if (infiniteButton.dataset.listenerAdded) return;
      infiniteButton.dataset.listenerAdded = 'true';

      // Initialize display state and grid properties
      if (!infiniteContent.style.display) {
        infiniteContent.style.display = 'none'; // Default to hidden
      }

      // Toggle function
      const toggleContent = () => {
        console.log('infinity button clicked');
        infiniteContent.style.display =
          infiniteContent.style.display === 'grid' ? 'none' : 'grid';
        infiniteButton.classList.toggle('rotated');
      };

      // Track touch start coordinates for infiniteButton
      let touchStartX = 0;
      let touchStartY = 0;
      const touchThreshold = 10; // Pixels of movement allowed before considering it a scroll

      infiniteButton.addEventListener('touchstart', (e) => {
        const touch = e.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      });

      // Add click and touchend for cross-device compatibility
      infiniteButton.addEventListener('click', toggleContent);
      infiniteButton.addEventListener('touchend', (e) => {
        e.preventDefault(); // Prevent default to avoid double triggering
        const touch = e.changedTouches[0];
        const touchEndX = touch.clientX;
        const touchEndY = touch.clientY;

        // Check if movement is within threshold
        const deltaX = Math.abs(touchEndX - touchStartX);
        const deltaY = Math.abs(touchEndY - touchStartY);
        if (deltaX < touchThreshold && deltaY < touchThreshold) {
          toggleContent();
        }
      });

      // Handle clicks on option wrappers
      swatchItem.querySelectorAll('.spb-productoptionswatchwrapper').forEach((wrapper) => {
        // Prevent duplicate event listeners
        if (wrapper.dataset.listenerAdded) return;
        wrapper.dataset.listenerAdded = 'true';

        // Track touch start coordinates for wrapper
        let wrapperTouchStartX = 0;
        let wrapperTouchStartY = 0;

        wrapper.addEventListener('touchstart', (e) => {
          const touch = e.touches[0];
          wrapperTouchStartX = touch.clientX;
          wrapperTouchStartY = touch.clientY;
        });

        wrapper.addEventListener('click', () => {
          const radioInput = wrapper.querySelector('input[type=radio]');
          if (radioInput) {
            // Ensure the radio is checked (handles re-clicking the same option)
            radioInput.checked = true;

            // Update button label and collapse content
            const labelText = wrapper.textContent.trim();
            infiniteButton.textContent = labelText;
            infiniteContent.style.display = 'none';
            infiniteButton.classList.remove('rotated');

            // Call updateProductDescFont if it exists
            if (typeof updateProductDescFont === 'function') {
              updateProductDescFont(swatchItem);
            }
          }
        });

        wrapper.addEventListener('touchend', (e) => {
          e.preventDefault(); // Prevent default to avoid double triggering
          const touch = e.changedTouches[0];
          const touchEndX = touch.clientX;
          const touchEndY = touch.clientY;

          // Check if movement is within threshold
          const deltaX = Math.abs(touchEndX - wrapperTouchStartX);
          const deltaY = Math.abs(touchEndY - wrapperTouchStartY);
          if (deltaX < touchThreshold && deltaY < touchThreshold) {
            const radioInput = wrapper.querySelector('input[type=radio]');
            if (radioInput) {
              radioInput.checked = true;

              // Update button label and collapse content
              const labelText = wrapper.textContent.trim();
              infiniteButton.textContent = labelText;
              infiniteContent.style.display = 'none';
              infiniteButton.classList.remove('rotated');

              // Call updateProductDescFont if it exists
              if (typeof updateProductDescFont === 'function') {
                updateProductDescFont(swatchItem);
              }
            }
          }
        });
      });
    }
  }

  // Initialize existing swatch items
  document.querySelectorAll('.infinite-swatches').forEach(initializeToggle);

  // Observe for dynamically added swatch items
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        // Check for new .infinite-swatches in added nodes
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.matches('.infinite-swatches')) {
              initializeToggle(node);
            }
            node.querySelectorAll('.infinite-swatches').forEach(initializeToggle);
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Handle radio input changes (for programmatic changes or keyboard navigation)
  document.addEventListener('change', (event) => {
    if (event.target.matches('.spb-productoptionswatchwrapper input[type=radio]')) {
      const swatchItem = event.target.closest('.infinite-swatches');
      if (swatchItem) {
        const checkedInput = swatchItem.querySelector('.spb-productoptionswatchwrapper input[type=radio]:checked');
        const infiniteButton = swatchItem.querySelector('.spb-productdescfont');
        const infiniteContent = swatchItem.querySelector('span');

        if (checkedInput && infiniteButton && infiniteContent) {
          // Update the infiniteButton label
          const label = checkedInput.closest('.spb-productoptionswatchwrapper');
          if (label) {
            const labelText = label.textContent.trim();
            infiniteButton.textContent = labelText;
          }

          // Hide the infiniteContent and update button state
          infiniteContent.style.display = 'none';
          infiniteButton.classList.remove('rotated');
        }

        // Call updateProductDescFont if it exists
        if (typeof updateProductDescFont === 'function') {
          updateProductDescFont(swatchItem);
        }
      }
    }
  });
});

/* ------------------------------------------------ */

// ** iCart Move Date Selector to the Bottom

window.addEventListener('load', function() {
    // Function to check and move the last child of .icart-section-element
    function moveLastSectionElement() {
        const lastSectionElement = document.querySelector('.icart-section-element:last-child');
        const checkoutContainer = document.querySelector('.icart-checkout-contain');

        // Check if both elements exist
        if (lastSectionElement && checkoutContainer) {
            // Check if the element is already inside the checkout container
            if (!checkoutContainer.contains(lastSectionElement)) {
                // Move the last section element to the top of the checkout container
                checkoutContainer.insertBefore(lastSectionElement, checkoutContainer.firstChild);
                console.log('Element moved successfully');
            } else {
                console.log('Element has already been moved');
            }
        } else {
            console.log('Elements not found, retrying...');
            // Retry after 500ms if the elements aren't found yet
            setTimeout(moveLastSectionElement, 500);
        }
    }

    // Call the function to move the element
    moveLastSectionElement();
});

/* ------------------------------------------------ */

// ** Display variant name in box builder dropdown

document.querySelectorAll('.ecom-product-single__swatch-item').forEach(item => {
    item.addEventListener('click', function() {
        // Add a 100ms delay
        setTimeout(() => {
            // Get the text content of the element with the class .ecom-product-single__variant-picker--selected-value (Text1)
            const selectedValue = document.querySelector('.ecom-product-single__variant-picker--selected-value').textContent;

            // Get the text content of the element with the class .ecom-product-single__price--sale (Text2)
            const salePrice = document.querySelector('.ecom-product-single__price--sale').textContent;

            // Update the text inside the element with the class .ecom-accordion__title-text
            document.querySelector('.ecom-accordion__title-text').textContent = `${selectedValue} (${salePrice})`;

            // Find elements with class .ecom-accordion_nav--icon
            document.querySelectorAll('.ecom-accordion_nav--icon').forEach(icon => {
                // If the icon has the class .ecom-items-icon-active
                if (icon.classList.contains('ecom-items-icon-active')) {
                    // Set display to block
                    icon.style.display = 'none';
                } else {
                    // Otherwise, set display to flex
                    icon.style.display = 'flex';
                }
            });


            // Find element with class .ecom-accordion__title and remove class .ecom-item-active
            const titleElement = document.querySelector('.ecom-accordion__title');
            if (titleElement) {
                titleElement.classList.remove('ecom-item-active');
            }

            // Find element with class .ecom-accordion__item and remove class .ecom-item-active
            const itemElement = document.querySelector('.ecom-accordion__item');
            if (itemElement) {
                itemElement.classList.remove('ecom-item-active');
            }

            // Find element with class .ecom-accordion__body and set its style height to 0
            const bodyElement = document.querySelector('.ecom-accordion__body');
            if (bodyElement) {
                bodyElement.style.height = '0';
            }

        }, 100);
    });
});

/* ------------------------------------------------ */

// ** Remove Variant Images from Ecomposer Product Slider

document.addEventListener('DOMContentLoaded', () => {
  // Select all elements with the class .ecom-swiper-slide
  const swiperSlides = document.querySelectorAll('.ecom-swiper-slide');

  // Loop through each element
  swiperSlides.forEach(slide => {
    // Get the value of the data-variant_id attribute
    const variantId = slide.getAttribute('data-variant_id');

    // Check if the data-variant_id has any value (not null, undefined, or empty string)
    if (variantId) {
      // Log the value of the data-variant_id before removing the element
      console.log(`Removing element with data-variant_id: ${variantId}`);
      
      // Remove the entire element from the DOM
      slide.remove();
    } else {
      // Log a notification if no data is found in the attribute
      console.warn('No data-variant_id found for element:', slide);
    }
  });
});

/* ------------------------------------------------ */

// ** Dropdown variant Tooltip Text

//$(document).ready(function() {
//  $('.ecom-product-single__swatch-item img').each(function() {
//    var altText = $(this).attr('alt');
//    $(this).attr('title', altText);
//  });
//});

// ** Remove In Stock text in PDP

document.addEventListener("DOMContentLoaded", function() {
    const statusElement = document.querySelector(".ecom-product-single-status--instock");
    if (statusElement && statusElement.textContent.trim() === "In Stock") {
        statusElement.style.display = "none";
    }
});

/* ------------------------------------------------ */

// ** iCart add to cart fixes

$(document).ready(function() {
  let observedProductTitle = null; // Store the title from MutationObserver
  let observedProductImageSrc = null; // Store the image src from MutationObserver
  let defaultProductImageSrc = null; // Default image src to be retrieved from the AJAX response
  let isBoldButtonClicked = false; // Track if the upsell add to cart button is clicked

  // Use MutationObserver to continuously watch for changes in .bold-product__title and .bold-product__image within .bold-product__details
  const observer = new MutationObserver((mutations) => {
    const boldProductTitle = $('.bold-product__details .bold-product__title');
    const boldProductImage = $('.bold-product__image');

    // Check for the title and update if available
    if (boldProductTitle.length) { 
      observedProductTitle = boldProductTitle.text(); 
      console.log('Bold product title detected:', observedProductTitle);
    }

    // Check for the image src and update if available
    if (boldProductImage.length) {
      observedProductImageSrc = boldProductImage.attr('src');
      console.log('Bold product image detected:', observedProductImageSrc);
    }
  });

  // Start observing the body for added nodes to detect bold product title and image
  observer.observe(document.body, { childList: true, subtree: true });

  // Track when the .bold-upsell__add_to_cart button is clicked
  $(document).on('click', '.bold-upsell__add_to_cart', function() {
    isBoldButtonClicked = true; 
    console.log('Bold upsell button clicked');
  });

  // Intercept the add-to-cart form submission
  $('form[action="/cart/add"]').submit(function(e) {
    e.preventDefault();

    const formData = $(this).serialize();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function(response) {
        console.log('Product added to cart:', response);

        // Retrieve default image source from the AJAX response
        if (response.image) {
          defaultProductImageSrc = response.image; // Assuming `response.image` contains the default image URL
        }

        // Show the cart bubble and update the count
        $('.cart-link__bubble').addClass('cart-link__bubble--visible');
        updateCartCount();

        // Update #added_to_cart--product-name based on conditions
        if (isBoldButtonClicked && observedProductTitle) {
          $('#added_to_cart--product-name').text(observedProductTitle);
        } else {
          $('#added_to_cart--product-name').text(response.title);
        }

        // Display observed image if isBoldButtonClicked and observedProductImageSrc are available
        if (isBoldButtonClicked && observedProductImageSrc) {
          $('#added_to_cart--product-img').attr('src', observedProductImageSrc);
          console.log('Updating image with bold product image:', observedProductImageSrc);
        } else {
          // If isBoldButtonClicked is true, enforce the default image
          $('#added_to_cart--product-img').attr('src', defaultProductImageSrc);
          console.log('Forcing default product image:', defaultProductImageSrc);
        }

        // Reset to default image after displaying observed image
        if (isBoldButtonClicked) {
          setTimeout(() => {
            if (defaultProductImageSrc) {
              $('#added_to_cart--product-img').attr('src', defaultProductImageSrc);
              console.log('Reverting to default product image:', defaultProductImageSrc);
            }
          }, 3000); // Adjust timeout as necessary
        }

        // Reset flags
        isBoldButtonClicked = false;

        // Show "added to cart" message
        showMessage();

        // Start observing the cart count element after the item is added
        observeCartCount();
      },
      error: function(error) {
        console.error('Error adding product to cart:', error);
      }
    });
  });

  function showMessage() {
    const messageElement = document.querySelector(".added_to_cart_message");
    if (messageElement) {
      messageElement.style.animation = "none";
      messageElement.style.display = "flex";
      void messageElement.offsetWidth;
      messageElement.style.animation = "fadeInUp 0.5s ease-in-out";

      setTimeout(() => {
        messageElement.style.animation = "fadeOutDown 0.5s ease-in-out";
        messageElement.addEventListener("animationend", () => {
          messageElement.style.display = "none";
        }, { once: true });
      }, 3000);
    }
  }

  function updateCartCount() {
    $.getJSON('/cart.js', function(cart) {
      let totalQuantity = 0;
      cart.items.forEach(function(item) {
        totalQuantity += item.quantity;
      });
      $('.cart-link__bubble').text(totalQuantity);
      currentCartCount = totalQuantity;
    });
  }

  let currentCartCount = 0;

  function observeCartCount() {
    const targetNode = document.querySelector('.cart-link__bubble');

    const observerCallback = function(mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          const displayedCount = parseInt($('.cart-link__bubble').text(), 10);
          if (displayedCount !== currentCartCount) {
            $('.cart-link__bubble').text(currentCartCount);
          }
        }
      }
    };

    const observerConfig = {
      childList: true,
      attributes: true,
      characterData: true,
      subtree: true
    };

    const observer = new MutationObserver(observerCallback);
    if (targetNode) {
      observer.observe(targetNode, observerConfig);
    }
  }
});

/* ------------------------------------------------ */

// ** Move 'Build your Box' dropdown selectors inside product details

document.addEventListener('DOMContentLoaded', () => {
    const infiniteObserver = new MutationObserver((mutations, obs) => {
        const infiniteOptions = document.querySelector('#infiniteoptions-container');
        const infiniteContainer = document.querySelector('#infiniteContainer');
        const ecomElement = infiniteContainer?.querySelector('.ecom-element');
        if (infiniteOptions && infiniteContainer && ecomElement) {
            ecomElement.appendChild(infiniteOptions);
            obs.disconnect();
        }
    });
    infiniteObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
});

/* ------------------------------------------------ */

/* Remove __upsell_recently_viewed_products and __upsell_market_id attributes from the cart

const originalFetch = window.fetch;
window.fetch = function (url, options) {
  if (url.includes('cart/update.js') && options && options.body) {
    try {
      const body = JSON.parse(options.body);
      if (body.attributes) {
        delete body.attributes.__upsell_recently_viewed_products;
        delete body.attributes.__upsell_market_id;
        options.body = JSON.stringify(body);
        if (Object.keys(body.attributes).length === 0) {
          return Promise.resolve({ ok: true, json: () => ({}) });
        }
      }
    } catch (e) {}
  }
  return originalFetch.apply(window, [url, options]);
};
document.addEventListener("DOMContentLoaded", function () {
  function removeUpsellElements() {
    const dataElements = document.querySelectorAll('[data-__upsell_recently_viewed_products], [data-__upsell_market_id]');
    dataElements.forEach(element => {
      element.remove();
    });
    const allElements = document.querySelectorAll('script, div, span, section, article');
    allElements.forEach(element => {
      const textContent = element.textContent || '';
      if (textContent.includes('__upsell_recently_viewed_products') || textContent.includes('__upsell_market_id')) {
        element.remove();
      }
    });
  }
  const upsellObserver = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      removeUpsellElements();
    });
  });
  upsellObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  });
  removeUpsellElements();
});

*/

